export const c_description_list_m_horizontal__term_width = {
  "name": "--pf-v6-c-description-list--m-horizontal__term--width",
  "value": "fit-content(20ch)",
  "var": "var(--pf-v6-c-description-list--m-horizontal__term--width)"
};
export default c_description_list_m_horizontal__term_width;